module.exports = {
  'en': {
    'HRES82EC1': {
      '10': 'For Date',
      '20': 'Available Time',
      '30': 'Room No.',
      '40': 'Details',
      '50': 'Status',
      '60': 'Reserved Time',
      '70': 'Reserve By',
      '80': 'Department',
      '90': 'Empty',
      '100': 'Detail of Meeting Room'
    },
    'HRES82EC2': {
      '10': 'Room No.',
      '20': 'Month',
      '30': 'Year',
      '40': 'SUN.',
      '50': 'MON.',
      '60': 'TUE.',
      '70': 'WED.',
      '80': 'THU.',
      '90': 'FRI.',
      '100': 'SAT.',
      '110': 'Details Of Reservation',
      '120': 'Seq No.',
      '130': 'Req. Date',
      '140': 'Reserve By',
      '150': 'Reservation Period',
      '160': 'Status',
      '170': 'Cancel By',
      '180': 'For Date'
    },
    'HRES82EC3': {
      '10': 'Room No',
      '20': 'Date',
      '30': 'Req.Date',
      '40': 'Reservation Period',
      '50': 'From Time',
      '60': 'To Time',
      '70': 'Status',
      '80': 'Reserve',
      '90': 'Cancel',
      '100': 'By',
      '110': 'By',
      '120': 'Objective',
      '130': 'Remark',
      '140': 'Capacity',
      '150': 'Persons'
    },
    'HRES82EC4': {
      '10': 'Detail of meeting room',
      '20': 'Room No.',
      '30': 'Room"s name',
      '40': 'Floor',
      '50': 'Building',
      '60': 'Capacity',
      '70': 'Persons',
      '80': 'Accessories',
      '90': 'Remark',
      '100': 'Status Of Room',
      '110': 'In Charge By',
      '120': 'Normal',
      '130': 'Under Repair'
    }
  },
  'th': {
    'HRES82EC1': {
      '10': 'สำหรับวัน',
      '20': 'ช่วงเวลาที่ว่าง',
      '30': 'หมายเลขห้อง',
      '40': 'รายละเอียด',
      '50': 'สถานะ',
      '60': 'ช่วงเวลาที่จอง',
      '70': 'จองโดย',
      '80': 'หน่วยงาน',
      '90': 'ว่าง',
      '100': 'รายละเอียดห้องประชุม'
    },
    'HRES82EC2': {
      '10': 'ห้องประชุม',
      '20': 'เดือน',
      '30': 'ปี',
      '40': 'อา.',
      '50': 'จ.',
      '60': 'อ.',
      '70': 'พ.',
      '80': 'พฤ.',
      '90': 'ศ.',
      '100': 'ส.',
      '110': 'รายละเอียดการจอง',
      '120': 'ลำดับที่',
      '130': 'วันที่ขออนุมัติ',
      '140': 'จองโดย',
      '150': 'ช่วงเวลาที่จอง',
      '160': 'สถานะ',
      '170': 'ยกเลิกโดย',
      '180': 'วันที่'
    },
    'HRES82EC3': {
      '10': 'ห้องประชุม',
      '20': 'วันที่',
      '30': 'วันที่ต้องการ',
      '40': 'ช่วงเวลาที่จอง',
      '50': 'เวลาเริ่มต้น',
      '60': 'เวลาสิ้นสุด',
      '70': 'สถานะการจอง',
      '80': 'จอง',
      '90': 'ยกเลิก',
      '100': 'โดย',
      '110': 'โดย',
      '120': 'วัตถุประสงค์',
      '130': 'รายละเอียดเพิ่มเติม',
      '140': 'จำนวนผู้เข้าประชุม',
      '150': 'คน'
    },
    'HRES82EC4': {
      '10': 'รายละเอียดห้องประชุม',
      '20': 'เลขที่ห้อง',
      '30': 'ชื่อห้อง',
      '40': 'ชั้น',
      '50': 'อาคาร',
      '60': 'ความจุ',
      '70': 'คน',
      '80': 'อุปกรณ์ที่มีอยู่',
      '90': 'รายละเอียดอื่นๆ',
      '100': 'สถานะห้องประชุม',
      '110': 'ผู้รับผิดชอบ',
      '120': 'ปกติ',
      '130': 'งดใช้ชั่วคราว'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres82e.js